import React, { useEffect, useState } from 'react';
import { api, setAuthToken } from '../api';
import './Dashboard.css';
import { useNavigate } from "react-router-dom";
import styled from 'styled-components';
import Corner from "../assets/corner.png";




function Dashboard() {
    const [rsvps, setRsvp] = useState([]);
    const [totalApprovedGuests, setTotalApprovedGuests] = useState([]);
    const [totalApprovedChild, setTotalApprovedChild] = useState([]);

    useEffect(() => {
        const fetchRsvps = async () => {
            try {
                const token = localStorage.getItem('token');
                if (token) {
                    setAuthToken(token);
                }
                const response = await api.get('/api/rsvp/getAll');
                const enrichedData = response.data.map(rsvp => ({
                    ...rsvp,
                    noGuest: 1 + (rsvp.guests ? rsvp.guests.length : 0)
                }));

                const totalApprovedGuests = enrichedData
                    .filter(item => item.status === 'Approved' && item.attending === true)
                    .reduce((total, item) => total + Number(item.noGuest || 0), 0);

                const totalApprovedChild = enrichedData
                    .filter(item => item.status === 'Approved' && item.attending === true)
                    .reduce((sum, item) => {
                        const childrenCount = item.guests?.filter(g => g.input2).length || 0;
                        return sum + childrenCount;
                    }, 0);

                setTotalApprovedGuests(totalApprovedGuests);
                setTotalApprovedChild(totalApprovedChild);
                setRsvp(enrichedData);
            } catch (err) {
                console.error("Failed to fetch RSVPs:", err);
            }
        };
        fetchRsvps();
    }, []);
    return (

        <div className='container'>
            <img src={Corner} className="corner top-left" alt="" />
            <img src={Corner} className="corner top-right" alt="" />
            <img src={Corner} className="corner bottom-left" alt="" />
            <img src={Corner} className="corner bottom-right" alt="" />

            <h1 style={{ textAlign: 'center', color: '#45354f' }} > RSVPs </h1>

            <p>Total Approved Children: <strong>{totalApprovedChild}</strong></p>
            <p>Total Approved Guests: <strong>{totalApprovedGuests}</strong></p>


            <div className='styled-table'>
                <div className='table-styled-header'>
                    <div className='table-cell'>Name</div>
                    <div className='table-cell'>Status</div>
                    <div className='table-cell'>Coming</div>
                    <div className='table-cell'>No. guest</div>
                    <div className='table-cell'>Email</div>
                </div>

                {rsvps.map((data) => (
                    <MissionRow key={data.id} data={data} />
                ))}
            </div>
        </div>
    );
}

function MissionRow({ data }) {
    const navigate = useNavigate();

    function navigateToMission() {
        navigate(`/RSVPApproval/${data.id}`);
    }

    const token = localStorage.getItem('token');
    if (token) {
        setAuthToken(token);
    }

    return (
        <div>


            <div className='styled-table-row' onClick={navigateToMission}>
                <div className='table-cell'> {data.name} </div>
                <div className='table-cell'> {data.status} </div>
                <div className='table-cell'> {data.attending ? 'Yes' : 'No'} </div>
                <div className='table-cell'> {data.noGuest} </div>
                <div className='table-cell.right'> {data.email} </div>
            </div>
        </div>
    );
}

export default Dashboard;